// HVAC Device Type Templates

import { Template02_Modern } from './Template02_Modern';

export { Template02_Modern } from './Template02_Modern';

// Template registry for dynamic selection
export const HvacTemplates = {
  Template02: () => import('./Template02_Modern').then(m => m.Template02_Modern),
} as const;

// Default export - using Template02 (Modern) as the default
export default Template02_Modern;
